import React, { useEffect, useState } from "react";
import { Layout, Row, Col, Space } from "antd";
import { StompSessionProvider, useSubscription } from "react-stomp-hooks";
import { AppointmentKanban } from "./AppointmentsKanban/AppointmentsKanban";
import dayjs from "dayjs";
import { getAppointments } from "../networkCalls";
import {
  columnOrder,
  columns,
  ColumnType,
} from "./AppointmentsKanban/appointmentsConstants";
import { useAuth } from "../../hooks/useAuth";
// import { toast } from "react-toastify";
// import { extractMessageContentsFromWsResponse } from "../utils";
import { responseObject, showToastType } from "../utils";
import config from "../../config/config";

import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  setAppointmentsData,
  IAppointmentsDataType,
} from "../../redux/reduxAppointments/appointmentsSlice";
import background from "../../bg-image-4.jpg";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { formatAppointments } from "../StaffHome/utils";

dayjs.extend(utc);
dayjs.extend(timezone);
const { Content } = Layout;
// const ws = new WebSocket(`ws://localhost:8080/wsendpoint`);
export function AppointmentController() {
  // const [message, setMessage] = useState("Your server message here.");
  const { token } = useAuth();
  return (
    <Content
      style={{
        backgroundImage: `url(
        ${background}
        )`,
      }}
      className="bg-fixed"
    >
      <StompSessionProvider
        url={
          config.WEB_SOCKET_ENDPOINT === undefined
            ? "ws://localhost:8000/websocket"
            : config.WEB_SOCKET_ENDPOINT
        }
        connectHeaders={{
          Authorization: "Bearer " + String(token ?? ""),
        }}

        //All options supported by @stomp/stompjs can be used here
      >
        <SubscribingComponent />
      </StompSessionProvider>
    </Content>
  );
}

export interface IAppointmentsDataTypeInput {
  consultingSlot: string;
  createdAt: string;
  createdBy: string;
  endDateTime: string;
  firstName: string;
  id: string;
  lastName: string;
  patientId: string;
  startDateTime: string;
  status: string;
  type: string;
  updatedAt: string;
  updatedBy: string;
}
function SubscribingComponent() {
  const appointmentsData = useAppSelector(
    (state) => state.appointments.appointmentsData
  );
  const dispatch = useAppDispatch();
  const [columnOrderState] = useState<string[]>(columnOrder);
  const [columnsData] = useState<{ [columnId: string]: ColumnType }>(columns);
  // const stompClient = useStompClient();

  useEffect(() => {
    (async () => {
      const appointmentResponseObject: responseObject = await getAppointments();
      const message = appointmentResponseObject["message"];
      const status = appointmentResponseObject["statusCode"];
      showToastType(message, status);
      const appointments = appointmentResponseObject[
        "data"
      ] as Array<IAppointmentsDataTypeInput>;
      dispatch(setAppointmentsData(formatAppointments(appointments)));
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Subscribe to /topic/test, and use handler for all received messages
  //Note that all subscriptions made through the library are automatically removed when their owning component gets unmounted.
  //If the STOMP connection itself is lost they are however restored on reconnect.
  //You can also supply an array as the first parameter, which will subscribe to all destinations in the array
  useSubscription("/topic/appointments", (message) => {
    console.log(message);
    var appointments = JSON.parse(message.body);
    console.log(appointments);
    console.log("WS Server sent event");
    if ("appointments" in appointments) {
      const appointmentsArray: Array<IAppointmentsDataTypeInput> =
        appointments["appointments"];
      showToastType("Retrieved latest Appointments", 200);
      dispatch(setAppointmentsData(formatAppointments(appointmentsArray)));
    }
  });
  return (
    <div style={{ overflowX: "auto" }}>
      <AppointmentKanban
        columnOrdering={columnOrderState}
        columnsData={columnsData}
        appointmentsData={appointmentsData}
      />
    </div>
  );
}
